

module.exports = __webpack_require__.stylable.create(
    "buttonnext2858163220",
    {"classes":{"root":"buttonnext2858163220__root","content":"buttonnext2858163220__content","prefix":"buttonnext2858163220__prefix","suffix":"buttonnext2858163220__suffix"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    2,
    "buttonnext2858163220",
    null
);
